/* eslint-disable */
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ProfileCreation from "../../candidate_profile_creation/components/ProfileCreation";
import CandidateHome from "../../home/components/Home";
import { logout } from "../../registration_login/actions/sessionActions";
import "../../styles/candidate_nav.css";
import Correspondence from "../../correspondence/components/Correspondence";
import MyAccount from "../../my_account/components/MyAccount";
// import MyAccount from "../../myAccount/components/MyAccount";
import Advertisement from "../../application_management/components/Advertisement";
import { setShowAdvertisementDetails, resetUploadeDocumentChecks } from "../../application_management/actions/advertisementAction";
import { getPrfileSummaryDetails, setProfileViewFlg, setPrintProfile, backToMyAccount, setApplicationDetailsFlg } from "../../my_account/actions/myAccountAction";
import advertisementDetailsLabels from "../../application_management/labels/advertisement_details_en.json"
import { useNavigate } from 'react-router-dom';
import commonLabels from "../../common/labels/common_en.json";
import Grievance from "../../common/components/Grievance";
import { Modal, Button } from 'react-bootstrap';
import { getEditProfileWithLock } from '../../common/actions/commonActions.js';
const CandidateNav = (props) => {
    const navigate = useNavigate();
    const [stepName, setName] = useState("1");
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const navToOnlineAppln = () => {
        setName("3");
        dispatch(setShowAdvertisementDetails(false, null));
        dispatch(resetUploadeDocumentChecks())
    };
    let { profileStatus } = useSelector(state => state.profile, shallowEqual);
    let { enableEditProfileWithLock } = useSelector(state => state.common, shallowEqual);

    let { updateProfileDone, isPrintProfileDone } = useSelector(state => state.myaccount, shallowEqual);

    useEffect(() => {
        updateProfileDone ? setName("2") : setName("1");
    }, [updateProfileDone]);

    useEffect(() => {
        profileStatus && setName("1");
    }, [profileStatus]);

    useEffect(() => {
        dispatch(getEditProfileWithLock())
    }, []);
    useEffect(() => {
        if (isPrintProfileDone) {
            document.getElementById("myaccount").click();
            dispatch(backToMyAccount(false))
        }
    }, [isPrintProfileDone]);

    useEffect(() => {
    }, [stepName])
    
    return (
        <div>
            <ul id="candidateNavBar" className="nav nav-tabs main-nav-tab bottom-shadow row top-nav m-0 custom-gutter">
                <li className="nav-item col" onClick={() => setName("1")}>
                    <a
                        className={`nav-link ${stepName === "1" ? "active" : "bg-light"}`}
                        href="#"
                    >
                        <img
                            src="/icons/home.svg"
                            className={`icons w15 ${stepName !== "1" ? "primary-filter" : "white-filter"}`}
                            alt="home icon"
                        />
                        <span className="ms-1">
                            {commonLabels.COMMON.HOME}
                        </span>
                    </a>
                </li>

                <li className="nav-item col" data-toggle="tooltip" title={`${profileStatus && enableEditProfileWithLock?.editProfileWithLock == "0" ? commonLabels.COMMON.CANDIDATE_PROFILE_NOTE : ""}`}>
                    <div
                        className={`${profileStatus &&  enableEditProfileWithLock?.editProfileWithLock == "0" ? "disabled-link" : ""}`}
                          onClick={() => setName("2")}>
                        <a
                            className={
                                stepName === "2"
                                    ? "nav-link active"
                                    : "nav-link bg-light"
                            }
                            href="#"
                        >
                            {" "}
                            <img src="/icons/profile_creation.svg" className={`icons w15 ${stepName !== "2" ? "primary-filter" : "white-filter"}`} />
                            <span className="ms-1" data-toggle="tab">
                                {commonLabels.COMMON.PROFILE_CREATION}
                            </span>
                        </a>
                    </div>
                    
                </li>
                
                <li className="nav-item col" onClick={navToOnlineAppln}>
                    <a
                        className={
                            stepName === "3"
                                ? "nav-link active"
                                : "nav-link bg-light"
                        }
                        href="#"
                    >
                        {" "}
                        <img src="/icons/online_application.svg" className={`icons w15 ${stepName !== "3" ? "primary-filter" : "white-filter"}`} />
                        <span className="ms-1">
                            {advertisementDetailsLabels.ONLINE_APPLICATION}
                        </span>
                    </a>
                </li>
                <li id="myaccount" className="nav-item col" onClick={() => { setName("4"); dispatch(getPrfileSummaryDetails()); dispatch(setPrintProfile(false)); dispatch(setProfileViewFlg()); dispatch(setApplicationDetailsFlg(false)) }}>
                    <a
                        className={
                            stepName === "4"
                                ? "nav-link active"
                                : "nav-link bg-light"
                        }
                        href="#"
                    >
                        {" "}
                        <img src="/icons/my_account.svg" className={`icons w15 ${stepName !== "4" ? "primary-filter" : "white-filter"}`} />
                        <span className="ms-1">
                            {commonLabels.COMMON.MY_ACCOUNT}
                        </span>
                    </a>
                </li>
                <li className="nav-item col" onClick={() => setName("5")}>
                    <a
                        className={
                            stepName === "5"
                                ? "nav-link active"
                                : "nav-link bg-light"
                        }
                        href="#"
                    >
                        {" "}
                        <img src="/icons/help.svg" className={`icons w15 ${stepName !== "5" ? "primary-filter" : "white-filter"}`} />
                        <span className="ms-1">
                            {commonLabels.COMMON.CORRESPONDENCE}
                        </span>
                    </a>
                </li>
                <li className="nav-item col" onClick={() => setName("6")}>
                    <a
                        className={
                            stepName === "6"
                                ? "nav-link active"
                                : "nav-link bg-light"
                        }
                        href="#"
                    >
                        {" "}
                        <img src="/icons/grievance.svg" className={`icons w10 ${stepName !== "6" ? "primary-filter" : "white-filter"}`} />
                        <span className="ms-1">
                            {commonLabels.SIGN_UP.GRIEVANCE}
                        </span>
                    </a>
                </li>
                
                <li className="nav-item col" onClick={() => setShowModal(true)}>
                    <a
                        className={
                            stepName === "7"
                                ? "nav-link active"
                                : "nav-link bg-light"
                        }
                        href="#"
                    >
                        <img
                            src="/icons/logout.svg"
                            className={`icons w15 ${stepName !== "7" ? "primary-filter" : "white-filter"
                                }`}
                        />
                        <span className="ms-1">{commonLabels.BUTTONS.LOGOUT}</span>
                    </a>
                </li>
                {/* <li
                    className="nav-item col"
                    onClick={() => {
                        setName("7");
                        dispatch(logout(props, true, navigate));
                    }}
                >
                    <a
                        className={
                            stepName === "7"
                                ? "nav-link active"
                                : "nav-link bg-light"
                        }
                        href="#"
                    >
                        {" "}
                        <img src="/icons/logout.svg" className={`icons w15 ${stepName !== "7" ? "primary-filter" : "white-filter"}`} />
                        <span className="ms-1">{commonLabels.BUTTONS.LOGOUT}</span>
                    </a>
                </li> */}
            </ul>

            <div className="tab-content candidateHomeTabCss">
                <div
                    className={
                        stepName === "1"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <CandidateHome {...props} />
                </div>
                <div
                    className={
                        stepName === "3"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <Advertisement setName={setName} />
                </div>
                <div
                    className={
                        stepName === "4"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <MyAccount   {...props} />
                </div>
                <div
                    className={
                        stepName === "5"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <Correspondence />
                </div>
                <div
                    className={
                        stepName === "6"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="grievance"
                    role="tabpanel"
                    aria-labelledby="grievance-tab"
                >
                    <Grievance />
                </div>
                <div
                    className={
                        stepName === "2"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <ProfileCreation  enableEditProfileWithLock={enableEditProfileWithLock} />
                </div>
                {/*<div
                    className={
                        stepName === "3"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <Advertisement />
                </div>
                <div
                    className={
                        stepName === "4"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <MyAccount   {...props}/>
                </div>
                <div
                    className={
                        stepName === "5"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                >
                    <Correspondence />
                </div>
                <div
                    className={
                        stepName === "6"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                ></div> */}
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header className="logout_heading">
                    <Modal.Title className="logout_title">{commonLabels.Confirm_Logout}</Modal.Title>
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => setShowModal(false)}
                    >X</button>
                </Modal.Header>

                <Modal.Body>{commonLabels.you_want_to_logout}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => {
                        setName("7");
                        dispatch(logout(props, true, navigate));
                    }}>
                        {commonLabels.BUTTONS.CONFIRM}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CandidateNav;
